import store from '../vuex/store'

const copyCommand = 'copy'
export const textCopyPl = 'Kopiuj do schowka'
export const textCopyEn = 'Copy to clipboard'
const textCopySuccessPl = 'skopiowano'
const textCopySuccessEn = 'copied'
const textCopySuccessClass = 'copy-success'
const textCopyErrorPl = 'błąd'
const textCopyErrorEn = 'error'
const textCopyErrorClass = 'copy-error'
const codeLineSelector = '.CodeMirror-line'

class Clipboard {
  constructor () {
    this.copyingAvailable = true

    try {
      document.execCommand(copyCommand)
    } catch (error) {
      this.copyingAvailable = false
    }
  }

  isCopyingAvailable () {
    return this.copyingAvailable
  }

  copyToClipboard (event) {
    const target = event.target
    const targetText = target.textContent
    const targetParent = target.parentElement.parentElement
    const langPl = store.state.sdk.lang === 'pl'
    let code = ''

    if (!this.copyingAvailable ||
      targetText === textCopySuccessPl ||
      targetText === textCopySuccessEn ||
      targetText === textCopyErrorPl ||
      targetText === textCopyErrorEn) {
      return false
    }

    const codeLines = targetParent.querySelectorAll(codeLineSelector)
    codeLines.forEach((line, index) => {
      if (line.textContent !== '\u200b') {
        code += line.textContent
        if (index < codeLines.length - 2) {
          code += '\n'
        }
      }
    })

    const el = document.createElement('textarea')
    el.value = code
    el.style = { position: 'absolute', left: '-9999px' }
    document.body.appendChild(el)
    el.select()

    if (document.execCommand(copyCommand)) {
      target.classList.add(textCopySuccessClass)
      target.textContent = langPl ? textCopySuccessPl : textCopySuccessEn
    } else {
      target.classList.add(textCopyErrorClass)
      target.textContent = langPl ? textCopyErrorPl : textCopyErrorEn
    }

    document.body.removeChild(el)

    setTimeout(() => {
      target.classList.remove(textCopySuccessClass)
      target.classList.remove(textCopyErrorClass)
      target.textContent = langPl ? textCopyPl : textCopyEn
    }, 1500)
  }
}

export let clipboardClass = new Clipboard()
